import { render, staticRenderFns } from "./TitluPagina.vue?vue&type=template&id=6b5a6cf6&scoped=true&"
import script from "./TitluPagina.vue?vue&type=script&lang=js&"
export * from "./TitluPagina.vue?vue&type=script&lang=js&"
import style0 from "./TitluPagina.vue?vue&type=style&index=0&id=6b5a6cf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a6cf6",
  null
  
)

export default component.exports